import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogContentText, InputAdornment } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import GetCurrency from "../../helper/GetCurrency";
import Checkbox from "@material-ui/core/Checkbox";
import _ from "lodash";
import { toast } from "react-toastify";
import { isEmpty } from "ramda";

export const paymentOptions = [
  "PIN",
  "IDEAL",
  "PAYPAL",
  "IDEALQR",
  "MASTERCARD",
  "SOFORT",
  "GIROPAY",
  "BANCONTACT",
  "PAYCONIQ",
  "EPS",
  "VISA",
  "AMEX",
];

const toast_values = {
  position: "bottom-right",
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export default function PaymentDialog(props) {
  const [paymentMethods, setPaymentMethods] = React.useState({});
  let paynl_sub = props.paymentSub;

  const initializePaymentMethods = () => {
    for (let paymentOption of paymentOptions) {
      if (props.paymentMode === "edit") {
        paymentMethods[paymentOption] = {
          checked: !!props.paymentSub.meta[paymentOption],
          count_price: !!props.paymentSub.meta[paymentOption] ? props.paymentSub.meta[paymentOption].count_price : "",
          amount_price: !!props.paymentSub.meta[paymentOption] ? props.paymentSub.meta[paymentOption].amount_price : "",
        };
      } else if (props.paymentMode === "add") {
        paymentMethods[paymentOption] = {
          checked: false,
          count_price: "",
          amount_price: "",
        };
      }
    }
    setPaymentMethods(_.cloneDeep(paymentMethods));
  };

  const closeDialog = () => {
    props.setPaymentMode(null);
    if (props.paymentMode === "add") {
      initializePaymentMethods();
    } else {
    }
  };

  const savePayment = () => {
    let methods = _.cloneDeep(paymentMethods);
    for (let key in methods) {
      if (methods[key]["checked"] === false) {
        delete methods[key];
        if (paynl_sub[key]) {
          delete paynl_sub[key];
        }
      } else {
        if (methods[key]["count_price"] === null || methods[key]["count_price"] === "") {
          toast.error(`Please fill in a count price for ${key}.`, toast_values);
          return;
        }
        delete methods[key]["checked"];
      }
    }
    Object.assign(paynl_sub, methods);
    props.setPaymentMode(null);
    props.setPaymentSub(paynl_sub);
  };

  const changeChecked = (key, value) => {
    paymentMethods[key]["checked"] = value;
    if (value === false) {
      paymentMethods[key]["count_price"] = "";
    }
    setPaymentMethods(_.cloneDeep(paymentMethods));
  };

  const changeCountPrice = (key, value) => {
    paymentMethods[key]["count_price"] = value;
    setPaymentMethods(_.cloneDeep(paymentMethods));
  };

  const changeAmountPrice = (key, value) => {
    paymentMethods[key]["amount_price"] = value;
    setPaymentMethods(_.cloneDeep(paymentMethods));
  };

  if (props.paymentMode && isEmpty(paymentMethods)) {
    initializePaymentMethods();
  }

  if (props.paymentMode === "add") {
    return (
      <Dialog open={props.paymentMode != null && !isEmpty(paymentMethods)} fullWidth maxWidth={"lg"}>
        <DialogTitle>Select Payment methods</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ marginBottom: "2em" }}>
            Check the appropriate payment methods and fill in a count_price for each selected method.
          </DialogContentText>
          <Grid container direction="row" spacing={2}>
            <Grid item>
              <Grid container direction="column" spacing={4}>
                {Object.keys(paymentMethods).map((key) => {
                  return (
                    <Grid item key={key}>
                      <FormControl variant="outlined">
                        <FormControlLabel
                          label={key}
                          labelPlacement="start"
                          control={
                            <Checkbox
                              checked={paymentMethods[key]["checked"]}
                              onChange={(event) => changeChecked(key, event.target.checked)}
                            />
                          }
                        />
                      </FormControl>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item>
              <Grid container direction="column" spacing={2}>
                {Object.keys(paymentMethods).map((key) => {
                  return (
                    <Grid item key={key}>
                      <FormControl>
                        <InputLabel>count price</InputLabel>
                        <OutlinedInput
                          type="number"
                          inputMode="decimal"
                          disabled={paymentMethods[key]["checked"] === false}
                          startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                          labelWidth={33}
                          onChange={(event) =>
                            changeCountPrice(key, event.target.value ? parseFloat(event.target.value) : null)
                          }
                          value={paymentMethods[key]["count_price"]}
                          inputProps={{
                            min: 0,
                            step: 0.01,
                          }}
                        />
                      </FormControl>
                      <FormControl>
                        <InputLabel>amount % price {"0.018 = 1.8%"}</InputLabel>
                        <OutlinedInput
                          type="number"
                          inputMode="decimal"
                          disabled={paymentMethods[key]["checked"] === false}
                          labelWidth={33}
                          onChange={(event) =>
                            changeAmountPrice(key, event.target.value ? parseFloat(event.target.value) : null)
                          }
                          value={paymentMethods[key]["amount_price"]}
                          inputProps={{
                            min: 0,
                            step: 0.01,
                          }}
                        />
                      </FormControl>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={savePayment}>Save</Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog open={props.paymentMode != null && !isEmpty(paymentMethods)} fullWidth maxWidth={"lg"}>
      <DialogTitle>Select Payment methods</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ marginBottom: "2em" }}>
          Check the appropriate payment methods and fill in a count_price for each selected method.
        </DialogContentText>
        <Grid container direction="row" spacing={2}>
          <Grid item>
            <Grid container direction="column" spacing={4}>
              {Object.keys(paymentMethods).map((key) => {
                return (
                  <Grid item key={key}>
                    <FormControl variant="outlined">
                      <FormControlLabel
                        label={key}
                        labelPlacement="start"
                        control={
                          <Checkbox
                            checked={paymentMethods[key]["checked"]}
                            onChange={(event) => changeChecked(key, event.target.checked)}
                          />
                        }
                      />
                    </FormControl>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="column" spacing={2}>
              {Object.keys(paymentMethods).map((key) => {
                return (
                  <Grid item key={key}>
                    <FormControl>
                      <InputLabel>count price</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        disabled={paymentMethods[key]["checked"] === false}
                        startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                        labelWidth={33}
                        onChange={(event) =>
                          changeCountPrice(key, event.target.value ? parseFloat(event.target.value) : null)
                        }
                        value={paymentMethods[key]["count_price"]}
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                    <FormControl>
                      <InputLabel>amount % price {"0.018 = 1.8%"}</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        disabled={paymentMethods[key]["checked"] === false}
                        labelWidth={33}
                        onChange={(event) =>
                          changeAmountPrice(key, event.target.value ? parseFloat(event.target.value) : null)
                        }
                        value={paymentMethods[key]["amount_price"]}
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={savePayment}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
